import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./integrations/sentry";
import App from "./App.tsx";
import "./index.css";

const AppCrashFallback = () => (
  <div className="min-h-screen w-full bg-gray-50 flex items-center justify-center p-6 text-center text-sm text-muted-foreground">
    Une erreur inattendue est survenue. L'équipe technique a été notifiée.
  </div>
);

const rootElement = document.getElementById("root");
const isProduction = import.meta.env.MODE === 'production';

if (rootElement) {
  createRoot(rootElement).render(
    isProduction ? (
      <Sentry.ErrorBoundary fallback={<AppCrashFallback />} showDialog>
        <App />
      </Sentry.ErrorBoundary>
    ) : (
      <App />
    )
  );
}
